/*
  Project: Ps2018
  Author: Krzysztof Malina
*/
/*
var $ = require('jquery');
window.jQuery = window.$ = $; // You expose jQ as a global object

var cookies = require('./cookies.js');
var googleFonts = require('./googlefonts.js');

var secondaryNav = require('./secondary-nav.js');
var taps = require('./taps.js');
var clickable = require('./clickable.js');
var heights = require('./heights.js');
var detectFlexbox = require('./detectflexbox.js');
var externalLinks = require('./external-links.js');
var animateTestimonials = require('./testimonials.js');

googleFonts();
detectFlexbox();
externalLinks();
animateTestimonials();
mobileNav();
secondaryNav();
taps();
clickable();
cookies();
heights();
*/
var mobileNav = require('./mobilenav.js');
var animations = require('./animations.js');
var konkurs = require('./konkursMM.js');

konkurs();
animations();
mobileNav();
